import "./Contact.module.css";
import FraternalExcellenceHeader from "@/reusable_sections/Header";
import LetsDesignYourKitchen from "./sections/LetsDesignYourKitchen";
import OurLocation from "./sections/OurLocation";
import InstitutionalTrustSignals from "./sections/InstitutionalTrustSignals";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <FraternalExcellenceHeader />
      <LetsDesignYourKitchen />
      <OurLocation />
      <InstitutionalTrustSignals />
      <Footer />
    </div>;
}